<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--심의평론-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC002144') }}</span>
				</div>
			</div>

			<sf-data-table
				:paging="false"
				:columns="cols"
				:rows="commentRows"
				:excel="false"
				:stripe="false"
				fit
				height="200px"
			></sf-data-table>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	computed: {
		...rootComputed,
		...serviceComputed,
		cols() {
			return [
				{ prop: 'rgnId', label: this.getMessage_('QWCC002145') },
				{ prop: 'rsltNm', label: this.getMessage_('QWCC000978') },
				{ prop: 'content', label: this.getMessage_('MWPE000025') },
				{ prop: 'rgnDt', label: this.getMessage_('QWCC002146') }
			];
		},
		commentRows(){
			return this.apprCommentList;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>
